
import React from 'react';
import { useTranslation } from 'react-i18next';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import ProductionForm from '@/components/production/ProductionForm';

const ProductionPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EditorialLayout>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">{t('production.title')}</h1>
        </div>
        
        <div className="bg-white rounded-lg shadow p-8">
          <h2 className="text-xl font-semibold mb-6">{t('production.createDirectInterview')}</h2>
          <ProductionForm />
        </div>
      </div>
    </EditorialLayout>
  );
};

export default ProductionPage;
